import cleanedFilename from '~/util/cleanedFilename';

export default {
  MENU_BUTTON: `${cleanedFilename(__filename)}-menu-button`,
};
